export default class enums {
  static updateUserStatusEnum = {
    none: 0,
    personalDataUpdated: 1,
    passwordChanged: 2,
    passwordDoesntChanged: 4,
		phoneConflict: 8,
		emailConflict: 16,
    personalDataDoesntUpdated: 32
  }
};